import { OrderType } from './stores';

interface TwoImage {
  id: number;
  name: string;
  description: string;
  startOn: string;
  endOn: string;
  citeies: any[];
  isCityLevel: boolean;
  content: string;
  sectionsType: number;
  status: number;
  countryId: number | null;
  isShuffaled: boolean;
  showingSectionTitle: boolean;
  showingSectionDescription: boolean;
  isRecommended: boolean;
}

interface ContentItem {
  Id: string;
  Tags: any[];
  ArabicImage: string | null;
  EnglishImage: string | null;
  ArabicVideo: string | null;
  EnglishVideo: string | null;
  Destination: number;
  DestinationValue: DestinationValue;
  MediaType: number;
}
export interface DestinationValue {
  BranchId: number | null;
  StoreId: string | null;
  IndustryId: number | null;
  SubIndustryId: number | null;
  ProductId: string | null;
  Branches: Branch[];
  ImagesDestination: any;
}
interface Branch {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  store: any;
  distance: number;
  isOpen: boolean;
  isExpress: boolean;
  acceptsBuyNowPayLater: boolean;
  orderTypes: OrderType[];
}

export enum DestinationValues {
  PRODUCT = 1,
  STORE = 2,
  LIST_OF_PRODUCTS = 3,
  CATEGORY = 4,
  SUBCATEGORY = 5,
  NO_DESTINATION = 6,
  LIST_OF_BRANCHES = 7,
  WEB_VIEW = 8,
  BROWSER = 9,
  IN_APP_NAVIGATION = 10,
}

interface Store {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  logoURL: string;
  isExpress: boolean;
  acceptsBuyNowPayLater: boolean;
  industries: any[]; // You might want to define a more specific type for industries if you have that information
}

export interface ITrandingStore {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  store: Store;
  distance: number;
  isOpen: boolean;
  isExpress: boolean;
  acceptsBuyNowPayLater: boolean;
}
